import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "scroll-progress",
  "aria-hidden": "true"
};
import { onMounted, onUnmounted, ref } from 'vue';
export default {
  __name: 'ScrollProgress',
  setup(__props) {
    const progress = ref(0);
    let frameId = null;
    const update = () => {
      frameId = null;
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      progress.value = max > 0 ? Math.min(1, Math.max(0, doc.scrollTop / max)) : 0;
    };

    /* scroll 事件里只登记一帧，避免高频重排 */
    const schedule = () => {
      if (frameId !== null) return;
      frameId = requestAnimationFrame(update);
    };
    onMounted(() => {
      update();
      window.addEventListener('scroll', schedule, {
        passive: true
      });
      window.addEventListener('resize', schedule);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (frameId !== null) cancelAnimationFrame(frameId);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
        class: "scroll-progress__bar",
        style: _normalizeStyle({
          transform: `scaleX(${progress.value})`
        })
      }, null, 4)]);
    };
  }
};